module.exports = __webpack_public_path__ + "img/discount-badge.808e169f.svg";